import Vue from 'vue'

/*
 * CONFIGURATIONS
 */
const environment = process.env.VUE_APP_ENV
const raygunApiKey = 'IV27IdYCP61eKtDUTwUgOQ'

/*
 * VENDOR AND GLOBAL
 */
const configureRaygunJs = ({ account }) => {
  if (environment === 'production' && typeof rg4js !== 'undefined') {
    rg4js('apiKey', raygunApiKey) // eslint-disable-line
    rg4js('enableCrashReporting', true) // eslint-disable-line
    rg4js('withTags', [environment, require('../publish/cache/app.json').version]) // eslint-disable-line
    Vue.config.errorHandler = function (err, vm, info) {
      rg4js('send', { // eslint-disable-line
        error: err,
        customData: [{ info: info }]
      })
    }

    account.on('changed', (user) => {
      if (user.id !== null) {
        rg4js('setUser', { // eslint-disable-line
          identifier: user.id,
          isAnonymous: false,
          email: user.email,
          firstName: user.first_name,
          fullName: user.first_name + ' ' + user.last_name
        })
      } else {
        rg4js('setUser', { // eslint-disable-line
          isAnonymous: true
        })
      }
    })
  }
}
const configureGlobalMixins = () => {
  Vue.mixin({
    methods: {
      $reset () {
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    }
  })
}

/*
 * COMMON
 */
const syncLocaleWithAccount = ({ account, locale }) => {
  locale.setLanguage(account.current.language)
  locale.setTimezone(account.current.timezone)

  account.$watch('current.language', language => { locale.setLanguage(language) })
  account.$watch('current.timezone', timezone => { locale.setTimezone(timezone) })
}
const dispatchRefreshEvent = ({ bus, account, api }) => {
  account.on('changed', () => {
    bus.emit('refresh')
  })
  api.on('maintenance_finished', () => {
    bus.emit('refresh')
  })
}
const configureCarrierJs = ({ account, carrier }) => {
  if (account.isAuthenticated) carrier.applyWebsocket()
  account.on('changed', () => {
    if (account.isAuthenticated) carrier.applyWebsocket()
  })
}
const handleApiDisconnections = ({ bus, account }) => {
  bus.on('api/disconnected', () => {
    account.logout()
  })
}

/*
 * SERVICES
 */
const refreshServicesOnRefreshEvent = ({ bus, services }) => {
  bus.on('refresh', () => {
    for (let name in services) {
      for (const destroyed of services[name].$options.destroyed) destroyed.apply(services[name])
      for (const created of services[name].$options.created) created.apply(services[name])
    }
  })
}

import { bus, account, api, locale, carrier, services } from './index'

configureRaygunJs({ account })
configureGlobalMixins()

syncLocaleWithAccount({ account, locale })
dispatchRefreshEvent({ bus, account, api })
configureCarrierJs({ account, carrier })
handleApiDisconnections({ bus, account })
refreshServicesOnRefreshEvent({ bus, services })